import React, { Component } from 'react';
import { Row, Col, Divider, Button } from 'antd';
import { VIEWS } from '../../../utils/yourAccountUtils';

export default class FooterControls extends Component {
    constructor(props) { super(props); }

    hasDisplayRole = () => !this.props.hasOwnProperty('displayRole') || this.props.displayRole !== 'p' ? false : true;
    isDisabled = () => this.props.hasOwnProperty('disableButtons') ? this.props.disableButtons : false;

    render() {
        const
        p = this.props,
        { services } = p;

        return (
            <div>
                <Divider type='horizontal' style={{ margin: '10px 0px' }} />
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col>

                            <Button
                                size='small'
                                icon='lock'
                                className='ya-fc-btn-2'
                                style={{ borderRadius: '20px' }}
                                onClick={() => services.changeView(VIEWS.CHANGE_PASSWORD)}
                                disabled={this.isDisabled()}
                            >
                                {'Change Password'}
                            </Button>
                            {!p.hasOwnProperty('displayRole') || p.displayRole !== 'p' ? null : (
                                <Button
                                    size='small'
                                    icon='mail'
                                    className='ya-fc-btn-3'
                                    style={{ borderRadius: '20px' }}
                                    onClick={() => services.changeView(VIEWS.EMAIL_PREFERENCES)}
                                    disabled={this.isDisabled()}
                                >
                                    {'Email Preferences'}
                                </Button>
                            )}
                        </Col>
                    </Row>
            </div>
        );
    }
}
